import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IPolicy } from '../../../../../../redux/slices/PolicyListSlice/types';
import { INTERNAL_ROUTES } from '../../../../../../utils/constants';
import {
    fetchModularAlaCarteBenefits,
    fetchModularPlans,
    resetModularState,
    setModularCurrentStep,
    setModularPolicy,
    setModularWalletBalance
} from '../../../../../../redux/slices/ModularEnrolmentSlice';
import { ModularEnrolmentSteps } from '../../../../../../redux/slices/ModularEnrolmentSlice/types';
import { setCurrentlySelectedPolicy } from '../../../../../../redux/slices/EnrolmentSlice';
import { ReduxState } from '../../../../../../redux';
import { fetchModularAddOnBenefits } from '../../../../../../redux/slices/ModularEnrolmentSlice/thunks';
import { FlagsmithFlags, useFeatureFlag } from '../../../../../../utils/flagsmith';

const useEnrolmentNavigation = (): ((policy: IPolicy) => void) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const userId = useSelector((state: ReduxState) => state.user?.userData?.data?.userId);
    const isModularAddOnsEnabled = useFeatureFlag(FlagsmithFlags.FAMILY_ADD_ONS);

    return useCallback(
        (policy: IPolicy) => {
            const isModular = policy.policySecondaryType === 'MODULAR';
            if (isModular) {
                const policyId = policy.policyId;
                dispatch(resetModularState());
                dispatch(setModularPolicy(policyId));
                dispatch(setModularWalletBalance(policy.walletAmount));
                dispatch(fetchModularPlans({ userId, policyId }));
                dispatch(setModularCurrentStep(ModularEnrolmentSteps.BASE_PLAN));
                dispatch(
                    fetchModularAlaCarteBenefits({ userId, policyId, benefitId: policy.benefits?.modular?.[0]?.id })
                );
                if (isModularAddOnsEnabled) {
                    dispatch(
                        fetchModularAddOnBenefits({
                            userId,
                            policyId,
                            benefitId: policy.benefits?.modular?.[0]?.id,
                            baseFamilyDefinition: policy.benefits?.modular?.[0]?.familyDefinition ?? ''
                        })
                    );
                }
                window.plotline('track', 'Clicked_register_now', { userId, policyId });
            } else dispatch(setCurrentlySelectedPolicy({ currentlySelectedPolicy: policy }));
            history.push(isModular ? INTERNAL_ROUTES.modular : INTERNAL_ROUTES.enrolment, {
                previousUrl: location.pathname
            });
        },
        [dispatch]
    );
};

export default useEnrolmentNavigation;
